import { VerificationResult } from "../playResult";
import { ScorpionRunLog } from "./scorpionRunLog";
import { ScorpionSolitaire } from "./scorpionSolitaire";

export class ScorpionVerificationResult extends VerificationResult<ScorpionSolitaire, ScorpionRunLog> {
}
